<template>
  <div
    class="half-circle-spinner"
    style="position: absolute;  bottom: 50%; right: 50%"
  >
    <div :style="divStyle">
      <div class="circle circle-1"></div>
      <div class="circle circle-2"></div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    ml: {
      type: String,
      default: null,
    },
    mt: {
      type: String,
      default: '80',
    },
  },
  computed: {
    divStyle() {
      if (this.ml === null) return 'margin-top: ' + this.mt + 'px;';

      return 'margin-top: ' + this.mt + 'px; margin-left: ' + this.ml + 'px;';
    },
  },
};
</script>
<style>
.half-circle-spinner,
.half-circle-spinner * {
  box-sizing: border-box;
}

.half-circle-spinner {
  width: 60px;
  height: 60px;
  border-radius: 100%;
  position: relative;
}

.half-circle-spinner .circle {
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 100%;
  border: calc(60px / 10) solid transparent;
}

.half-circle-spinner .circle.circle-1 {
  border-top-color: lightskyblue;
  animation: half-circle-spinner-animation 1s infinite;
}

.half-circle-spinner .circle.circle-2 {
  border-bottom-color: lightskyblue;
  animation: half-circle-spinner-animation 1s infinite alternate;
}

@keyframes half-circle-spinner-animation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
